function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.2606 5.77344H2.41699M22.1186 8.98573L21.5276 17.8517C21.3001 21.2618 21.1871 22.9669 20.0756 24.0064C18.9642 25.0459 17.2539 25.0472 13.836 25.0472H12.8415C9.42364 25.0472 7.71342 25.0472 6.60197 24.0064C5.49051 22.9669 5.37616 21.2618 5.15001 17.8517L4.55895 8.98573M10.1265 12.198L10.769 18.6226M16.5511 12.198L15.9086 18.6226",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.92738,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27148 5.7737H6.41283C6.92994 5.76048 7.43102 5.59152 7.85055 5.28891C8.27008 4.9863 8.58852 4.56413 8.76422 4.07761L8.80791 3.94526L8.93255 3.57135C9.0392 3.2514 9.09316 3.09207 9.16383 2.95587C9.30287 2.68911 9.50242 2.4586 9.74651 2.28278C9.9906 2.10696 10.2725 1.99072 10.5695 1.94336C10.7199 1.91895 10.8882 1.91895 11.2248 1.91895H15.4522C15.7889 1.91895 15.9572 1.91895 16.1075 1.94336C16.4046 1.99072 16.6865 2.10696 16.9305 2.28278C17.1746 2.4586 17.3742 2.68911 17.5132 2.95587C17.5839 3.09207 17.6379 3.2514 17.7445 3.57135L17.8691 3.94526C18.032 4.48656 18.3687 4.95907 18.8273 5.28962C19.2858 5.62017 19.8406 5.79031 20.4056 5.7737",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.92738
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.59ed0f37c0266344ebe35640e1f0952c.svg";
export { ForwardRef as ReactComponent };